import React from 'react';
import { CtaButton } from './CtaButton';
export function StickyCta() {
  return <div className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-navy-900/95 px-4 py-3 backdrop-blur sm:hidden" data-id="element-206" data-mp="3bluibg04c666">
      <CtaButton size="md" label="🚀 GET CRICKET READY — $27" data-id="element-207" data-mp="2xnebzq664hok" />
    </div>;
}